'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$SitesByCredentialGroup(hash, code) {
  this.ZI = null;
  this.ZH = null;
  this.ZI = hash;
  this.ZH = code;
}
export { $c_Lpresto_types$proto$SitesByCredentialGroup as $c_Lpresto_types$proto$SitesByCredentialGroup };
$p = $c_Lpresto_types$proto$SitesByCredentialGroup.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$SitesByCredentialGroup;
/** @constructor */
function $h_Lpresto_types$proto$SitesByCredentialGroup() {
}
export { $h_Lpresto_types$proto$SitesByCredentialGroup as $h_Lpresto_types$proto$SitesByCredentialGroup };
$h_Lpresto_types$proto$SitesByCredentialGroup.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$SitesByCredentialGroup) && ((this.ZI === x$0.ZI) && (this.ZH === x$0.ZH))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "SitesByCredentialGroup";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.ZI;
  }
  if ((n === 1)) {
    return this.ZH;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$SitesByCredentialGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lO)));
}
export { $isArrayOf_Lpresto_types$proto$SitesByCredentialGroup as $isArrayOf_Lpresto_types$proto$SitesByCredentialGroup };
var $d_Lpresto_types$proto$SitesByCredentialGroup = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$SitesByCredentialGroup, "presto.types$proto$SitesByCredentialGroup", ({
  lO: 1,
  eg: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$SitesByCredentialGroup as $d_Lpresto_types$proto$SitesByCredentialGroup };
//# sourceMappingURL=presto.types$proto$-Sites-By-Credential-Group.js.map
